"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = exports.SliderTypes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Slider_1 = __importDefault(require("@mui/material/Slider"));
var SliderTypes;
(function (SliderTypes) {
    SliderTypes["PRIMARY"] = "primary";
    SliderTypes["SECONDARY"] = "secondary";
    SliderTypes["SUCCESS"] = "success";
    SliderTypes["WARNING"] = "warning";
    SliderTypes["DANGER"] = "danger";
    SliderTypes["UNKNOWN"] = "unknown";
})(SliderTypes = exports.SliderTypes || (exports.SliderTypes = {}));
var Slider = function (props) {
    var className = props.className, valueLabelFn = props.valueLabelFn, shouldHideThumb = props.shouldHideThumb, type = props.type, restProps = __rest(props, ["className", "valueLabelFn", "shouldHideThumb", "type"]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "slider d-flex align-items-center ".concat(type ? "slider--".concat(type) : "slider--".concat(SliderTypes.PRIMARY), " ").concat(className || "", " ").concat(shouldHideThumb ? "slider--hide-thumb" : ""), "data-showvaluelabel": props.valueLabelDisplay }, { children: [(0, jsx_runtime_1.jsx)(Slider_1.default, __assign({}, restProps)), valueLabelFn && typeof valueLabelFn === "function" ? ((0, jsx_runtime_1.jsx)("span", __assign({ className: "slider__value-label ml-3" }, { children: valueLabelFn(props.value) }))) : null] })));
};
exports.Slider = Slider;
